export const RECORD_MAPPING: { [key: string]: string } = {
  Service: "0128c000001zT4PAAU",
  Invoice: "0128c000001zT4PAAU",
  Relocation: "0128c000001zT4PAAU",
  "Lease Extension": "0128c000001zT4PAAU",
  Return: "0128c000001zT4PAAU",
  "AP Information": "0128c000001zT4PAAU",
};

export const ORIGINAL_SERVICE_NAME: { [key: string]: string } = {
  "Service a unit": "Service",
  "Invoice review": "Invoice",
  "Relocate a unit": "Relocation",
  "Lease extension": "Lease Extension",
  "Return a unit": "Return",
  "AP Information": "AP Information",
};

export const ZIP_CODE_API_URL = "https://api.zippopotam.us";

export const COUNTRY_SHORT_NAME: { [key: string]: string } = {
  "united states": "us",
  canada: "ca",
};

export const API_CONFIG = {
  BASE_URL: process.env.NEXT_PUBLIC_API_HOST,
  GUEST_KEY: process.env.NEXT_GUEST_PAYMENT_KEY,
  ENDPOINTS: {
    registration: "/api/registration",
    invoices: "/api/invoices",
    payment: "/api/payment",
    validateUser: "/api/validateExistingUser",
    getOpenInvoiceItems: "api/invoices/openItems",
    partialPayment: "/services/requestAService",
  },
};

export const OTHERS_SELECT_OPTION_CODE = {
  othersReasonCode: "008",
};

export const GP_ERROR_MSG =
  "There is a system issue at the moment. Please try again after some time or contact our Team at 800-782-1500 to complete the payment.";

export const GP_ERROR_MSG_FR =
  "Il y a actuellement un problème système. Veuillez réessayer plus tard ou contacter notre équipe au 800-782-1500 pour compléter le paiement.";

export const CardTypes = {
  Visa: "VISA",
  AmericanExpress: "AMEX",
  MasterCard: "MAST",
  Echeck: "ACH",
  Discovery: "DISC",
  EcheckFullName: "echeck",
};

export const ValidateUser = {
  success: "Success",
};

export const CUSTOMER_TYPE_FOR_SITE_ADDRESS = "WE";
export const CUSTOMER_TYPE_FOR_BILL_TO_ADDRESS = "RE";
